/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.client.internal

import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import systems.frictionless.impulse.rest.CustomHeaders
import systems.frictionless.impulse.rest.client.model.Progress
import systems.frictionless.impulse.rest.model.Index

internal fun Headers.getLinkHeader() = get(HttpHeaders.Link)

internal fun Headers.getCurrentIndex() = Index(get(CustomHeaders.CURRENT_INDEX)!!.toInt())

internal fun Headers.getCount() = Index(get(CustomHeaders.FINAL_INDEX)!!.toInt())

internal fun Headers.getProgress() = Progress(getCurrentIndex(), getCount())
